import React, { useContext, useEffect, useState } from 'react'
import { Button, Notification, toast } from 'components/ui'
import { CompanyContext } from 'contexts/CompanyContext'
import { PriorityModalContext } from 'contexts/PriorityModalContext';
import { openSocialNetworkConnect } from 'api/socialNetworkConnect';
import capitalize from 'components/ui/utils/capitalize';
import { Trans } from 'react-i18next';
import { useWhitelabel } from 'contexts/WhitelabelThemeContext';

const PinterestIntegrationModal = () => {

    const { closeModalPriority } = useContext(PriorityModalContext);
    const { company, companySocials } = useContext(CompanyContext);
    const [ isLoading, setIsLoading ] = useState(false);
    const { whitelabel, frontendUrl } = useWhitelabel();

    const network = "pinterest";

    const handleSubmit = () => {
        if (!openSocialNetworkConnect(company?.id, network, frontendUrl)) return;
        setIsLoading(true);
    }
    
    useEffect(() => {
        if (companySocials?.filter(e => e.type == network)?.length > 0) {
            toast.push(<Notification title={`${capitalize(network)} successfully connected!`} type="success" />);
            localStorage.removeItem("social_network_updated");
            closeModalPriority();
        }
    }, [companySocials])

    return (
        <>
            <div className='flex flex-col gap-8 pt-4'>
                <img src={`/img/socials-3d/${network}.png`} className='w-28 mx-auto drop-shadow' />
                <h3 className='text-tertiary-900 mega-title text-center'><Trans i18nKey={`pinterestIntegration.title`}>Pinterest Integration</Trans></h3>
                <p className='text-center !text-base'><Trans i18nKey={`pinterestIntegration.quickAndEasy`}>Connecting your Pinterest account is quick and easy. Simply click the "Connect with Pinterest" button below, and you'll be redirected to authorize the connection between your Pinterest profile and {whitelabel?.name}.</Trans></p>
                <p className='text-center !text-base'><Trans i18nKey={`pinterestIntegration.makeSure`}>Make sure that you are connected to the right Pinterest account before connecting to {whitelabel?.name}.</Trans></p>
            </div>

            <div className='flex justify-end gap-2 p-4 -m-6 w-auto mt-10 border-t border-gray-200 dark:border-gray-700'>
                <Button onClick={closeModalPriority}><Trans i18nKey={`pinterestIntegration.cancel`}>Cancel</Trans></Button>
                <Button loading={isLoading} variant="solid" onClick={handleSubmit} icon={<img src={`/img/socials/${network}.svg`} className="!h-4 !w-4 shrink-0" />}>&nbsp; <Trans i18nKey={`pinterestIntegration.connectWith`}>Connect with Pinterest</Trans></Button>
            </div>
        </>
    )
}

export default PinterestIntegrationModal
